export const VossCreditKind = {
    Normal: 0,
    Internal: 1
}

export const VossCreditKindText = {
    [VossCreditKind.Normal]: "vossCreditKind.normal",
    [VossCreditKind.Internal]: "vossCreditKind.internal"
}